var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.98 6.09C22.329 4.932 21.6225 4.719 20.184 4.638C18.747 4.5405 15.1335 4.5 12.003 4.5C8.8665 4.5 5.2515 4.5405 3.816 4.6365C2.3805 4.719 1.6725 4.9305 1.0155 6.09C0.345 7.2465 0 9.2385 0 12.7455V12.7575C0 16.2495 0.345 18.2565 1.0155 19.401C1.6725 20.559 2.379 20.769 3.8145 20.8665C5.2515 20.9505 8.8665 21 12.003 21C15.1335 21 18.747 20.9505 20.1855 20.868C21.624 20.7705 22.3305 20.5605 22.9815 19.4025C23.658 18.258 24 16.251 24 12.759V12.747C24 9.2385 23.658 7.2465 22.98 6.09ZM9 17.25V8.25L16.5 12.75L9 17.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1cbfc92e7b66b121d4db385cb88c1f2c.svg";
export { ForwardRef as ReactComponent };